import { useEffect } from 'react'
import ZoomManager from './components/ZoomManager'
import { formatTimestamp } from './utils/formatTimeStamp'

const ZoomMeeting = ({
  token,
  brand,
  documentTitle,
  meetingNumber,
  password,
  language,
  startDate,
  endDate,
  userRole,
}: {
  token: string
  brand: string
  documentTitle: string
  meetingNumber: string
  password: string
  language: string
  startDate: string
  endDate: string
  userRole: number
}) => {
  useEffect(() => {
    document.title = documentTitle
    const handleBeforeUnload = () => {
      localStorage.removeItem('permissionsDenied')
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [documentTitle])

  const formatedEndDate = formatTimestamp(Number(endDate), language)
  const formatedStartDate = formatTimestamp(Number(startDate), language)

  return (
    <div>
      <ZoomManager
        token={token}
        isChecked={true}
        brand={brand}
        meetingNumber={meetingNumber}
        passWord={password}
        language={language}
        startDate={formatedStartDate}
        endDate={formatedEndDate}
        userRole={userRole}
      />
    </div>
  )
}

export default ZoomMeeting
